import '.././style/loading.css'

export default function Loading () {
    return (
        <div className="loading">
            <div className="color"></div>
        </div>
    )
}